import(/* webpackMode: "eager" */ "/app/src/app/dev/(console)/page.tsx");
